import _ from 'lodash';

import {
  Card,
  CardContent
} from '@mui/material';

import { MessageData } from 'generated/graphql';
import { SimpleDataTable } from 'modules/components/layer22';
import { useMemo } from 'react';



export type GlAccountDataTableProps = {
  data: MessageData | null;
  showLatest5Years?: boolean;
};

export const FC = (props: GlAccountDataTableProps) => {
  const {
    periods,
    years
  } = useMemo(() => {
    const periods = props.data?.values
      .filter((v) => (
        v.period === 'q1'
        || v.period === 'q2'
        || v.period === 'q3'
        || v.period === 'q4'
        || v.period === 'fy'
      ))
      .map((v) => v.period.toUpperCase());

    const years = _.sortBy(_.uniq(props.data?.values.map((v) => v.year) ?? []));

    return {
      periods: _.sortBy(_.uniq(periods)),
      years: props.showLatest5Years ? _.takeRight(years, 5) : years
    };
  }, [
    props.data?.values,
    props.showLatest5Years
  ]);

  return (
    <Card>
      <CardContent>
        <SimpleDataTable.FC
          domain={years.map((y) => y.toString())}
          range={periods}
          data={props.data?.values.map((v) => ({
            value: v.formattedValue,
            x: v.year.toString(),
            y: v.period.toUpperCase()
          })) ?? []}
          emptyCasePlaceholder='-'
        />
      </CardContent>
    </Card>
  );
};
